<template>
  <div class="navicon-container">
    <button type="button" :class="['navicon', { open: mobileMenu }]" @click="toggle()">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </button>
  </div>
</template>

<script>
export default {
  methods: {
    toggle() {
      if (this.mobileMenu) {
        this.$store.dispatch("toggleMobileMenu", false);
        this.$store.dispatch("closeSubMenu");
      } else {
        this.$store.dispatch("toggleMobileMenu", true);
      }
    }
  },
  computed: {
    mobileMenu() {
      return this.$store.getters.getShowMobileMenu;
    }
  }
};
</script>
